import { refreshAccessToken } from "../utils/authClient";
import { tokenStore } from "../utils/tokenStore";

type RefreshFn = () => Promise<string | null>;   // trả token mới hoặc null
type OnUnauthorized = () => void;                // chuyển hướng login

export function makeFetchWithAuth(
  baseFetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>,
  opts?: { refresh?: RefreshFn; onUnauthorized?: OnUnauthorized }
) {
  const refresh = opts?.refresh ?? refreshAccessToken;
  const onUnauthorized = opts?.onUnauthorized;

  return async (input: RequestInfo | URL, init?: RequestInit) => {
    const headers = new Headers(init?.headers || {});
    const { token } = tokenStore.get();

    if (token) headers.set("Authorization", `Bearer ${token}`);

    const doFetch = (reqInit?: RequestInit) =>
      baseFetch(input, { ...init, ...reqInit, headers });

    let res = await doFetch();

    if (res.status === 401) {
      // thử refresh nếu có
      if (refresh) {
        const newToken = await refresh().catch(() => null);
        if (newToken) {
          headers.set("Authorization", `Bearer ${newToken}`);
          res = await doFetch();
        } else {
          tokenStore.clear();
          onUnauthorized?.();
        }
      } else {
        tokenStore.clear();
        onUnauthorized?.();
      }
    }

    return res;
  };
}
